import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                联系我们
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] lg:max-w-none mb-7">
                {contactInfo.desc}
              </p>
              <div className="flex flex-col gap-3 items-center lg:items-start">
                <div className="inline-flex items-center gap-3 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-700 font-medium">{contactInfo.email}</span>
                </div>
                <div className="inline-flex items-center gap-3 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-qq-line text-accent-500"></i>
                  </div>
                  <span className="text-sm text-foreground-700 font-medium">{contactInfo.qq}</span>
                </div>
                <div className="inline-flex items-center gap-3 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-line text-secondary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-700 font-medium">{contactInfo.wechat}</span>
                </div>
              </div>
            </div>

            <div className="flex-1 w-full max-w-[480px]">
              <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4 text-center">快速留言</h3>
                <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
                  <div>
                    <input
                      type="text"
                      placeholder="您的昵称"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="您的邮箱"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    />
                  </div>
                  <div>
                    <textarea
                      rows={4}
                      placeholder="请输入留言内容..."
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="whitespace-nowrap w-full py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200"
                  >
                    发送留言
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}